// extracted by mini-css-extract-plugin
module.exports = {"root":"HomepageSlots_root__2ACAs","useFade-fadeIn":"HomepageSlots_useFade-fadeIn__ijdiR","useFade-fadeOut":"HomepageSlots_useFade-fadeOut__23eER"};